import {Text} from "components/styled"
import React from "react"
import Lightbox from "react-lightbox-component"
import "react-lightbox-component/build/css/index.css"
import styled from "styled-components"

const formatImages = imgList =>
    imgList.map(img => ({
        src: img,
    }))

const FeedbackItem = ({feedback}) => {
    const formattedImages = formatImages(feedback.photos)

    return (
        <Card>
            <Text.span light>{feedback.created_at_formatted} by </Text.span>
            <Text.span>{feedback.user.display_name}</Text.span>
            <Text lighter className="feedback-title">
                {feedback.feedback}
            </Text>
            <Lightbox showImageModifiers={false} images={formattedImages}/>
            {feedback && feedback.threads && feedback.threads.length ? (
                <div className="comment-section">
                    {feedback.threads.map((thread, index) => (
                        <div key={index} className="comment-list">
                            <div>
                                <span>
                                    {thread.replied_at.diff} by&nbsp;
                                </span>
                                <span>{thread.replied_by.display_name} </span>
                            </div>
                            <div className="comment-inner">
                                <p>{thread.reply}</p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : ""}
        </Card>
    )
}

const Card = styled.li`
  padding: 10px 40px 30px;
  margin: 10px 0;
  border-bottom: 1px solid #3b4555;

  .feedback-title {
    font-size: 13px;
    margin: 4px 0 10px;
  }

  .images {
    &:before,
    &:after {
      content: "";
      display: block;
      clear: both;
    }

    img {
      float: left;
      width: 116px;
      height: 75px;
      margin: 0 8px 8px 0;
      border: 1px solid #0d1015;
      border-radius: 4px;
      object-fit: cover;
    }
  }
  
  .comment-section {
    span {
      margin-bottom: 4px;
      display: inline-block;
      text-align: right;
      font-size: 12px;
      color: var(--color-theme-1);
    }
    
    p {
      margin: 0;
      font-size: 14px;
    }
  }
  
  .comment-inner {
    background: #222934;
    padding: 10px 16px;
    font-size: 12px;
    color: rgba(255,255,255,0.7);
    border-radius: 4px;
  }
    
  .comment-list div:first-child {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  
  .comment-list div:first-child span:nth-child(2) {
    color: #fff;
    font-weight: 400;
  }
  
  .comment-list:not(:first-child) {
    margin-top: 16px;
  }
`

export default FeedbackItem



// WEBPACK FOOTER //
// ./src/pages/project/detail/feedback/feedback-item.js